import { useEffect } from "react";
import { initializePaddle } from "@paddle/paddle-js";

function getSuccessState(plan) {
  const value = String(plan || "").trim().toLowerCase();

  if (value === "starter") return "starter_success";
  if (value === "pro") return "pro_success";
  if (value === "extra_pack") return "extra_success";

  return "success";
}

export default function PaddleCheckoutHandler() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get("_ptxn");
    const plan = params.get("plan");

    if (!transactionId) return;

    let mounted = true;
    let completed = false;

    async function openPaddleCheckout() {
      const successState = getSuccessState(plan);

      const paddle = await initializePaddle({
        environment:
          process.env.REACT_APP_PADDLE_ENVIRONMENT === "sandbox"
            ? "sandbox"
            : "production",
        token: process.env.REACT_APP_PADDLE_CLIENT_TOKEN,
        eventCallback: (event) => {
          if (!mounted) return;

          if (event?.name === "checkout.completed") {
            completed = true;

            // Let Paddle checkout show its completed state briefly,
            // then return to Krionex with a clear app-level success banner.
            window.setTimeout(() => {
              if (!mounted) return;
              window.location.href = `/upgrade?checkout=${successState}`;
            }, 1500);
          }

          if (event?.name === "checkout.closed" && !completed) {
            window.location.href = "/upgrade?checkout=cancel";
          }
        },
      });

      if (!mounted || !paddle) return;

      paddle.Checkout.open({
        transactionId,
        settings: {
          displayMode: "overlay",
          theme: "light",
        },
      });
    }

    openPaddleCheckout().catch((err) => {
      console.error("[paddle checkout] failed", err);
      window.location.href = "/upgrade?checkout=cancel";
    });

    return () => {
      mounted = false;
    };
  }, []);

  return null;
}